<template>
  <div>
    <component :is="layout">
      <router-view v-if="dataReady"></router-view>
    </component>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      dataReady: false,
    };
  },
  computed: {
    layout() {
      //Вернем имя шаблона из роута или дефолтное значение
      //(шаблон для страниц, для которых мы не указали шаблон)
      return this.$route.meta.layout || "full";
    },
  },
  async mounted() {
    window.BX24.init(() => {
      let placementInfo = BX24.placement.info();

      if (BX24.isAdmin()) {
        // console.log( 'Зашел администратор' )
        this.$store.commit("isAdmin", true);
        this.$store
          .dispatch("installation", { root: true })
          .then(() => (this.dataReady = true));
      }

      // Смена роута в зависимости от места вызова
      switch (placementInfo.placement) {
        case "TASK_VIEW_TAB":
          this.$router.push("/task").catch((failure) => console.log(failure));
          break;
        case "CRM_DEAL_DETAIL_TAB":
          this.$router.push("/deal").catch((failure) => console.log(failure));
          break;
        case "CRM_COMPANY_DETAIL_TAB":
          this.$router
            .push("/company")
            .catch((failure) => console.log(failure));
          break;
        case "CRM_CONTACT_DETAIL_TAB":
          this.$router
            .push("/contact")
            .catch((failure) => console.log(failure));
          break;
        case "USER_PROFILE_TOOLBAR":
          this.$router.push("/user").catch((failure) => console.log(failure));
          break;
        default:
          // console.log( 'Место вызова - default' );
          break;
      }
      // Получаем список пользователей и пишем его в state
      this.$store
        .dispatch("getAllUsers", null, { root: true })
        .then((result) => {
          if (result) {
            this.$store.commit("setUsers", result, { root: true });
          }
        });
      // Получаем товары каталога №19 и пишем в store
      this.$store
        .dispatch("getProducts", null, { root: true })
        .then((result) => {
          if (result) {
            this.$store.commit("setProducts", result, { root: true });
          }
        });
    });
  },
  methods: {},
  components: {
    alert,
  },
};
</script>

<style scoped>
.nav_menu {
  margin-bottom: 10px;
  padding: 5px;
  border-radius: 5px;
  background-color: #b3d8fd;
}
</style>
